// extracted by mini-css-extract-plugin
module.exports = {"KareemLinks":"Kareem_KareemLinks__XJe9V","registerDiv":"Kareem_registerDiv__39JZ0","col":"Kareem_col__2VFns"};